import { cn } from '~/styles/extended-theme';
import { type PropsWithClassName } from '~/utils/props-with-classname';

interface Props {
  title: string;
  description: string;
  image?: string;
}

export default function ValueProposition({
  title,
  description,
  image,
  className,
}: PropsWithClassName<Props>) {
  return (
    <div className={cn('mb-6 flex items-center gap-4', className)}>
      {image !== undefined ? <img src={image} alt="" className="h-20 w-20 rounded" /> : null}

      <div>
        <h2 className="text-subtitle1">{title}</h2>
        <p className="text-body2">{description}</p>
      </div>
    </div>
  );
}
